export enum ReleaseDistributionStatusEnum {
  NEVER_DISTRIBUTED = 'NEVER_DISTRIBUTED',
  PROCESSING = 'PROCESSING',
  DISTRIBUTED = 'DISTRIBUTED',
  ISSUES = 'ISSUES',
  TAKEN_DOWN = 'TAKEN_DOWN',
}
